/*
 *  Loyalty Banner
 *
 *  Version:
 *    1.0.0 - 2024/11/08
 */

document.querySelectorAll("[data-loyalty-banner]").forEach(container => {
  const interval = setInterval(() => {
    const historySelector = ".yotpo-action-buttons-tile .yotpo-action-button.yotpo-secondary-button"
    const historyButton = container.querySelector(historySelector);

    if (historyButton) {
      historyButton.addEventListener("click", (e) => {
        container.parentElement.classList.toggle("has-popup");
      })

      clearInterval(interval);
    }
  }, 200);
})